/* Fiche produit Bellaziza (15/10/2026) : variantes, stock, quantité, rubriques en panneau, photos en grand,
   barre « Ajouter au panier » (téléphone) et « Vous aimerez aussi ». L'ajout au panier passe par <product-form> du thème. */
(function () {
  'use strict';
  var reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // 17/10 (traductions) : textes dans la langue de la page (bloc data-bz-fp-textes de bz-fiche-produit), français par défaut
  var TX = {};
  try { TX = JSON.parse((document.querySelector('[data-bz-fp-textes]') || {}).textContent || '{}'); } catch (e) {}
  function tx(k, fr) { return TX[k] || fr; }

  // prix : « 1 250 € » / « 29,99 € » en euros ; format de la devise sinon (marchés)
  var DEVISE = 'EUR';
  function euros(cents) {
    var x = cents / 100;
    if (DEVISE !== 'EUR') { try { return new Intl.NumberFormat('fr-BE', { style: 'currency', currency: DEVISE }).format(x); } catch (e) {} }
    var s = new Intl.NumberFormat('fr-BE', { minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2 }).format(x).replace(/[\u202f\u00a0]/g, ' ');
    return s + '\u00a0€';
  }
  // « 24x20 » → « 24 × 20 cm » (cotes sans unité, lues en cm : R43)
  function cotes(t) {
    t = String(t || '');
    var unite = /\d\s*(cm|mm|m)\b|″|"|\bcm\b/i.test(t);
    return t.replace(/(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)(?:\s*[x×]\s*(\d+(?:[.,]\d+)?))?(?!\d|[.,]\d)/gi, function (m, a, b, c) { return a + ' × ' + b + (c ? ' × ' + c : '') + (unite ? '' : ' cm'); }).replace(/(\d)(cm|mm)\b/g, '$1 $2');
  }

  function init(S) {
    if (S.dataset.bzPret) return;
    S.dataset.bzPret = '1';
    document.documentElement.classList.add('bz-fp-page');
    var $ = function (s, r) { return (r || S).querySelector(s); };
    var $$ = function (s, r) { return [].slice.call((r || S).querySelectorAll(s)); };

    var variantes = [];
    try { variantes = JSON.parse($('[data-bz-variantes]').textContent); } catch (e) {}
    var unique = S.dataset.pieceUnique === '1';
    DEVISE = S.dataset.devise || 'EUR';
    // cotes par taille, lues dans la description (« S: 24x20 - M: 32x30 - L: 41x31 »)
    var cotesParValeur = {};
    String(S.dataset.dims || '').split(/\s+-\s+|;|\n/).forEach(function (m) {
      var k = m.split(':'); if (k.length < 2) return;
      var cle = k[0].trim().toLowerCase(), val = k.slice(1).join(':').trim();
      if (cle && val && cle.length <= 12) cotesParValeur[cle] = cotes(val);
    });
    function cotesDe(valeur) {
      var v = String(valeur || '').toLowerCase().trim();
      if (cotesParValeur[v]) return cotesParValeur[v];
      return cotesParValeur[v.split(/[\s+]/)[0]] || '';
    }
    var form = $('form[data-type="add-to-cart-form"]');
    var idInput = form && form.querySelector('[name="id"]');
    var ajout = $('.bz-fp-form .bz-fp-ajout');
    var qte = $('[data-bz-qte]'), qteInput = $('[data-bz-qte-input]');
    var galerie = $('.bz-fp-galerie');
    var barre = $('[data-bz-barre-bas]');
    var retour = null, iv = 0, photos = [];

    /* ---------- variantes ---------- */
    var options = $$('.bz-fp-option');
    function choix() { return options.map(function (o) { var b = $('.bz-fp-valeur[aria-pressed="true"]', o); return b ? b.dataset.valeur : null; }); }
    function trouver(c) { return variantes.filter(function (v) { return v.options.every(function (x, i) { return x === c[i]; }); })[0]; }
    function courante() { if (!variantes.length) return null; if (!options.length) return variantes[0]; return trouver(choix()) || null; }

    // épuisé = aucune variante en vente avec cette valeur ; « autre » = en vente, mais pas avec les autres choix actuels
    function marquerEpuises() {
      var c = choix();
      options.forEach(function (o, i) {
        $$('.bz-fp-valeur', o).forEach(function (b) {
          var ok = variantes.some(function (v) { return v.dispo && v.options[i] === b.dataset.valeur; });
          var ici = variantes.some(function (v) { return v.dispo && v.options[i] === b.dataset.valeur && v.options.every(function (x, k) { return k === i || x === c[k]; }); });
          b.classList.toggle('epuise', !ok);
          b.classList.toggle('autre', ok && !ici);
          b.title = ok && !ici ? tx('autre_choix', 'Disponible avec un autre choix') : '';
          if (ok) b.removeAttribute('aria-disabled'); else b.setAttribute('aria-disabled', 'true');
        });
      });
    }

    function texteStock(v) {
      if (!v || !v.dispo) return '';
      if (!v.suivi) return tx('en_stock', 'En stock');
      if (v.stock <= 1) return unique ? tx('piece_unique', 'Pièce unique : un seul exemplaire') : tx('dernier', 'Dernier exemplaire');
      if (v.stock <= 3) { var pq = tx('plus_que', 'Plus que {n} en stock'); return pq.indexOf('{n}') > -1 ? pq.replace('{n}', v.stock) : pq + v.stock; }
      return tx('en_stock', 'En stock');
    }

    function majQte(v) {
      if (!qte || !qteInput) return;
      var montrer = v && v.dispo && (!v.suivi || v.stock > 1);
      qte.hidden = !montrer;
      var max = v && v.suivi ? Math.max(1, v.stock) : 99;
      qteInput.max = max;
      var n = Math.min(max, Math.max(1, parseInt(qteInput.value, 10) || 1));
      qteInput.value = montrer ? n : 1;
      $('[data-qte="-1"]', qte).disabled = n <= 1;
      $('[data-qte="1"]', qte).disabled = n >= max;
    }

    function photoEnTete(mediaId) {
      if (!mediaId || !galerie) return;
      var b = $('.bz-fp-ph[data-media="' + mediaId + '"]', galerie);
      if (!b) return;
      if (window.matchMedia('(max-width: 749px)').matches) {
        galerie.scrollTo({ left: b.offsetLeft - galerie.offsetLeft, behavior: reduit ? 'auto' : 'smooth' });
      } else if (galerie.firstElementChild !== b) {
        galerie.insertBefore(b, galerie.firstElementChild);
        $$('.bz-fp-ph', galerie).forEach(function (x, k) { x.dataset.i = k; x.classList.toggle('bz-fp-ph--cache', k > 4 && !galerie.classList.contains('tout')); });
      }
    }

    // BookX réactive les boutons « add » au chargement : l'état passe par la classe et aria-disabled (product-form.js le respecte)
    function etatBouton(btn, dispo) {
      if (!btn) return;
      btn.disabled = !dispo;
      btn.classList.toggle('bz-fp-ajout--epuise', !dispo);
      if (dispo) btn.removeAttribute('aria-disabled'); else btn.setAttribute('aria-disabled', 'true');
    }

    var gfActuel = false;
    function appliquer(v, depuisClic) {
      options.forEach(function (o, i) {
        var val = v ? v.options[i] : choix()[i];
        $$('.bz-fp-valeur', o).forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.valeur === val ? 'true' : 'false'); });
        var lib = $('[data-bz-option-val]', o); if (lib) { var cv = cotesDe(val); lib.textContent = (val || '') + (cv ? ' · ' + cv : ''); }
      });
      if (!v) {
        if (ajout) { etatBouton(ajout, false); $('[data-bz-ajout-txt]', ajout).textContent = tx('indisponible', 'Indisponible'); }
        return;
      }
      if (idInput) idInput.value = v.id;
      marquerEpuises();
      // la Sun liste enregistre la variante choisie
      var wl = $('.bz-fp-coeur [data-wlh-id]'); if (wl) { wl.setAttribute('data-wlh-variantid', v.id); wl.setAttribute('data-wlh-price', (v.prix / 100).toFixed(2)); }
      // ateliers : le prix affiché est le prix complet de l'atelier (data-bz-fixe), jamais l'acompte
      var px = $('[data-bz-prix]'); if (px && !px.hasAttribute('data-bz-fixe')) px.textContent = euros(v.prix);
      var b = $('[data-bz-barre]'), r = $('[data-bz-remise]');
      if (!b || !r) {} else if (v.barre > v.prix) { b.textContent = euros(v.barre); r.textContent = '−' + Math.round((v.barre - v.prix) * 100 / v.barre) + ' %'; b.hidden = r.hidden = false; }
      else { b.hidden = r.hidden = true; }
      var st = $('[data-bz-stock]'); if (st) { st.hidden = !v.dispo; $('span', st).textContent = texteStock(v); }
      etatBouton(ajout, v.dispo); if (ajout) $('[data-bz-ajout-txt]', ajout).textContent = v.dispo ? (ajout.dataset.bzTxt || tx('ajouter', 'Ajouter au panier')) : tx('epuise', 'Épuisé');
      if (barre && !barre.hasAttribute('data-bz-barre-atelier')) { $('[data-bz-barre-prix]', barre).textContent = euros(v.prix); etatBouton($('.bz-fp-ajout', barre), v.dispo); }
      majQte(v);
      // R-461 : grand format par variante (retrait à Mons / devis) : texte sous le bouton
      var pr = $('[data-bz-promesse]'); if (pr && pr.dataset.gf) pr.textContent = v.gf ? pr.dataset.gf : pr.dataset.normal;
      gfActuel = !!v.gf;
      if (depuisClic) {
        photoEnTete(v.photo);
        try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString()); } catch (e) {}
      }
    }

    marquerEpuises();
    appliquer(courante(), false);

    /* ---------- rubriques en panneau ---------- */
    var tiroir = $('[data-bz-tiroir]');
    function ouvrirRub(k, bouton) {
      if (k === 'liv' && gfActuel && $('template[data-rub="liv-gf"]')) k = 'liv-gf';
      var t = $('template[data-rub="' + k + '"]');
      if (!t) return;
      retour = bouton || document.activeElement;
      $('h2', tiroir).textContent = t.dataset.titre;
      tiroir.setAttribute('aria-label', t.dataset.titre);
      var corps = $('.bz-fp-tiroir-corps', tiroir);
      corps.innerHTML = ''; corps.appendChild(t.content.cloneNode(true)); corps.scrollTop = 0;
      if (k === 'dim') $$('p', corps).forEach(function (p) { p.textContent = cotes(p.textContent); });
      S.classList.add('tiroir-ouvert'); document.documentElement.classList.add('bz-fp-bloque');
      setTimeout(function () { $('.bz-fp-fermer', tiroir).focus({ preventScroll: true }); }, 30);
    }
    function fermerRub() {
      if (!S.classList.contains('tiroir-ouvert')) return;
      S.classList.remove('tiroir-ouvert'); document.documentElement.classList.remove('bz-fp-bloque');
      if (retour) retour.focus({ preventScroll: true });
    }

    /* ---------- photos en grand ---------- */
    var vision = $('[data-bz-vision]');
    function montrer(i) {
      iv = (i + photos.length) % photos.length;
      var img = $('img', vision), src = photos[iv];
      img.src = src.dataset.grand || src.currentSrc || src.src; img.alt = src.alt;
      $('.bz-fp-vision-n', vision).textContent = (iv + 1) + ' / ' + photos.length;
      $$('.bz-fp-vision-f', vision).forEach(function (b) { b.hidden = photos.length < 2; });
    }
    function ouvrirVision(i, bouton) {
      photos = $$('.bz-fp-ph img', galerie); if (!photos.length) return;
      retour = bouton; montrer(i);
      S.classList.add('vision-ouverte'); document.documentElement.classList.add('bz-fp-bloque');
      setTimeout(function () { $('.bz-fp-fermer', vision).focus({ preventScroll: true }); }, 30);
    }
    function fermerVision() {
      if (!S.classList.contains('vision-ouverte')) return;
      S.classList.remove('vision-ouverte'); document.documentElement.classList.remove('bz-fp-bloque');
      if (retour) retour.focus({ preventScroll: true });
    }

    /* ---------- clics ---------- */
    S.addEventListener('click', function (ev) {
      if (ev.target.hasAttribute && ev.target.hasAttribute('data-bz-voile')) return fermerRub();
      var t = ev.target.closest('button'); if (!t || !S.contains(t)) return;
      if (t.classList.contains('bz-fp-rub')) return ouvrirRub(t.dataset.rub, t);
      if (t.classList.contains('bz-fp-fermer')) return t.closest('[data-bz-vision]') ? fermerVision() : fermerRub();
      if (t.classList.contains('bz-fp-ph')) return ouvrirVision($$('.bz-fp-ph', galerie).indexOf(t), t);
      if (t.classList.contains('bz-fp-vision-f')) return montrer(iv + (t.classList.contains('d') ? 1 : -1));
      if (t.hasAttribute('data-bz-plus')) { galerie.classList.add('tout'); $$('.bz-fp-ph--cache', galerie).forEach(function (x) { x.classList.remove('bz-fp-ph--cache'); }); t.hidden = true; return; }
      if (t.dataset.qte) {
        var max = parseInt(qteInput.max, 10) || 99;
        qteInput.value = Math.min(max, Math.max(1, (parseInt(qteInput.value, 10) || 1) + parseInt(t.dataset.qte, 10)));
        $('[data-qte="-1"]', qte).disabled = +qteInput.value <= 1; $('[data-qte="1"]', qte).disabled = +qteInput.value >= max;
        return;
      }
      if (t.classList.contains('bz-fp-ajout--barre')) { if (ajout && !ajout.classList.contains('bz-fp-ajout--epuise')) ajout.click(); return; }
      if (t.classList.contains('bz-fp-ajout--date')) { allerDate(); return; }
      if (t.classList.contains('bz-fp-valeur')) {
        if (t.getAttribute('aria-disabled') === 'true') return;
        var o = t.closest('.bz-fp-option'), i = options.indexOf(o), c = choix(); c[i] = t.dataset.valeur;
        var v = trouver(c);
        if (!v || !v.dispo) v = variantes.filter(function (x) { return x.dispo && x.options[i] === t.dataset.valeur; })[0] || v;
        appliquer(v, true);
      }
    });
    if (qteInput) qteInput.addEventListener('change', function () { majQte(courante()); });
    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape') { fermerVision(); fermerRub(); }
      if (S.classList.contains('vision-ouverte') && (ev.key === 'ArrowRight' || ev.key === 'ArrowLeft')) montrer(iv + (ev.key === 'ArrowRight' ? 1 : -1));
    });

    /* ---------- points sous les photos (téléphone) ---------- */
    var points = $('.bz-fp-points');
    if (galerie && points) {
      galerie.addEventListener('scroll', function () {
        var i = Math.round(galerie.scrollLeft / Math.max(1, galerie.clientWidth));
        $$('span', points).forEach(function (s, k) { s.classList.toggle('on', k === i); });
      }, { passive: true });
    }

    /* ---------- barre du bas (téléphone) : visible une fois le bouton passé ---------- */
    /* ateliers (MAQ1, 21/10) : visible tant que le bloc de réservation n'est pas à l'écran ; un appui y descend */
    var atelier = barre && barre.hasAttribute('data-bz-barre-atelier');
    var blocDate = $('.bz-fp-achat--atelier');
    function allerDate() {
      var c = $('.bookeasy-btn') || blocDate; if (!c) return;
      var lent = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: c.getBoundingClientRect().top + window.scrollY - Math.round(window.innerHeight * 0.3), behavior: lent ? 'auto' : 'smooth' });
    }
    function majBarre() {
      if (atelier) {
        if (!blocDate) return;
        var r = blocDate.getBoundingClientRect(), dehors = r.top > window.innerHeight - 60 || r.bottom < 60;
        S.classList.toggle('barre-vue', dehors); /* bulle « Chat » des ateliers : voir majChat (24/10) */
        return;
      }
      if (!ajout || !barre) return;
      var vu = ajout.getBoundingClientRect().bottom < 0;
      S.classList.toggle('barre-vue', vu);
      document.documentElement.classList.toggle('bz-fp-barre-vue', vu);
    }
    window.addEventListener('scroll', majBarre, { passive: true });
    majBarre();

    /* ---------- bulle « Chat » (Shopify Inbox), 23-24/10 ----------
       Ordinateur : effacée tant qu'elle serait sur les photos (zone galerie, « Voir plus de photos » compris) ; elle revient dessous ;
       une fois touchée par le visiteur, elle reste (sur ordinateur elle ne couvre qu'un coin de photo).
       Téléphone, fiche : visible seulement avec la barre d'achat du bas, relevée au-dessus d'elle (bz-fiche.css, classe bz-fp-barre-vue).
       Téléphone, atelier : visible avec la barre « Choisir ma date », relevée, et seulement si le titre, le prix et le bloc de réservation
       ne passent pas sous elle (place réelle de la bulle, mesurée). Sur téléphone, une bulle fermée suit toujours ces règles (24/10, Nour).
       Cachée = aussi l'attribut inert (sinon le bouton intérieur de Shopify reste cliquable et atteignable au clavier).
       Jamais cachée quand la conversation est ouverte (attribut open). */
    var zoneGal = $('.bz-fp-galerie-zone') || $('.bz-fp-galerie'), chatUtilise = false, chatSuivi = null, activateur = null;
    var RELEVE = 72; /* = translateY(-72px) de html.bz-fp-barre-vue shopify-chat dans bz-fiche.css */
    function majChat() {
      var c = document.querySelector('shopify-chat'), d = document.documentElement, large = window.innerWidth >= 750, cacher;
      if (c && c !== chatSuivi && window.MutationObserver) {
        chatSuivi = c;
        new MutationObserver(majChat).observe(c, { attributes: true, attributeFilter: ['open'] });
      }
      if (large) {
        var r = zoneGal ? zoneGal.getBoundingClientRect() : null, h = window.innerHeight;
        cacher = !chatUtilise && !!r && r.left < 140 && r.top < h - 10 && r.bottom > h - 100;
      } else if (atelier) {
        var montrer = S.classList.contains('barre-vue') && !sousBulle(c);
        d.classList.toggle('bz-fp-barre-vue', montrer);
        cacher = !montrer;
      } else {
        cacher = !d.classList.contains('bz-fp-barre-vue');
      }
      if (c && c.hasAttribute('open')) cacher = false;
      d.classList.toggle('bz-chat-sur-photo', large && cacher);
      if (c && c.hasAttribute('inert') !== cacher) c.toggleAttribute('inert', cacher);
    }
    function trouverActivateur(racine) {
      if (!racine) return null;
      var a = racine.querySelector('[part~="activator"]');
      if (a) return a;
      var tous = racine.querySelectorAll('*');
      for (var i = 0; i < tous.length; i++) {
        if (tous[i].shadowRoot) { a = trouverActivateur(tous[i].shadowRoot); if (a) return a; }
      }
      return null;
    }
    function sousBulle(c) {
      /* place de la bulle une fois relevée au-dessus de la barre, d'après sa vraie position (barre d'aperçu, encoche…) ;
         à défaut, sa place mesurée le 24/10 sur iPhone (20 px du bas, 94 × 50 px, relevée de 72 px) */
      var h = window.innerHeight, haut = h - 150, bas = h - 84, gauche = 0, droite = 124;
      if (c) {
        if (!activateur || !activateur.isConnected) activateur = trouverActivateur(c.shadowRoot);
        var r = activateur && activateur.getBoundingClientRect();
        if (r && r.width) {
          var t = getComputedStyle(c).transform, dy = 0;
          if (t && t !== 'none' && window.DOMMatrixReadOnly) dy = new DOMMatrixReadOnly(t).m42;
          haut = r.top - dy - RELEVE - 8; bas = r.bottom - dy - RELEVE + 8; gauche = r.left - 8; droite = r.right + 8;
        }
      }
      return $$('.bz-fp-tete, .bz-fp-prix, .bz-fp-achat').some(function (el) {
        var e = el.getBoundingClientRect();
        return e.height > 0 && e.left < droite && e.right > gauche && e.top < bas && e.bottom > haut;
      });
    }
    function chatTouche(e) {
      if (chatUtilise || !e.target || !e.target.closest || !e.target.closest('shopify-chat')) return;
      chatUtilise = true; document.documentElement.classList.add('bz-chat-utilise'); majChat();
    }
    document.addEventListener('pointerdown', chatTouche, true);
    document.addEventListener('focusin', chatTouche, true);
    window.addEventListener('scroll', majChat, { passive: true });
    window.addEventListener('resize', majChat);
    var essais = 0, attente = setInterval(function () { majChat(); if (chatSuivi || ++essais > 40) clearInterval(attente); }, 500);
    majChat();
  }

  /* ---------- « Vous aimerez aussi » : section rendue par Shopify ---------- */
  function reco(R) {
    if (R.dataset.bzPret) return;
    R.dataset.bzPret = '1';
    var url = R.dataset.bzRecoUrl;
    /* fiche atelier : rangée déjà rendue (les autres ateliers), seulement les flèches */
    if (url) fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var d = document.createElement('div'); d.innerHTML = html;
      var neuf = d.querySelector('.bz-fp-reco');
      /* 23/10 : recommandations Shopify du même univers (étiquette theme-… ou type), puis la famille rendue avec la page, puis le reste, sans doublon */
      var rail = R.querySelector('.bz-fp-rail');
      var max = parseInt(R.dataset.bzNombre, 10) || 8, type = R.dataset.bzType || '';
      var themes = (R.dataset.bzThemes || '').split(' ').filter(Boolean);
      var proches = [], autres = [], garde = [], vus = {};
      if (neuf) [].forEach.call(neuf.querySelectorAll('.bz-fp-carte'), function (li) {
        var lt = (li.dataset.bzThemes || '').split(' ');
        var proche = (type && li.dataset.bzType === type) || themes.some(function (x) { return lt.indexOf(x) > -1; });
        (proche ? proches : autres).push(li);
      });
      var famille = rail ? [].slice.call(rail.children) : [];
      /* au moins 4 cartes du même univers ou de la famille : pas de complément hors univers */
      if (proches.length + famille.length >= 4) autres = [];
      proches.concat(famille, autres).forEach(function (li) {
        var a = li.querySelector('.bz-fp-carte-lien');
        if (garde.length >= max || !a || vus[a.pathname]) return;
        vus[a.pathname] = 1; garde.push(li);
      });
      if (garde.length) {
        if (!rail) { R.innerHTML = neuf.innerHTML; rail = R.querySelector('.bz-fp-rail'); }
        rail.innerHTML = '';
        garde.forEach(function (li) { rail.appendChild(li); });
        document.dispatchEvent(new CustomEvent('bz:reco-chargee', { detail: { section: R } }));
      } else { R.hidden = true; }
    }).catch(function () { if (!R.querySelector('.bz-fp-rail')) R.hidden = true; });
    R.addEventListener('click', function (ev) {
      var t = ev.target.closest('[data-rail]'); if (!t) return;
      var rail = R.querySelector('.bz-fp-rail'); if (!rail) return;
      rail.scrollBy({ left: parseInt(t.dataset.rail, 10) * rail.clientWidth * 0.8, behavior: reduit ? 'auto' : 'smooth' });
    });
  }

  function demarrer() {
    [].forEach.call(document.querySelectorAll('.bz-fp'), init);
    [].forEach.call(document.querySelectorAll('.bz-fp-reco'), reco);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer); else demarrer();
  document.addEventListener('shopify:section:load', demarrer);
})();
